<div class="or-d-flex or-align-items-center or-py-12-px or-px-16-px or-cursor-pointer channel-item">
  @if (channelTypeIcon()) {
    <div class="or-mr-8-px channel-type-avatar">
      <img [src]="channelTypeIcon()" class="channel-type-icon" alt="channel type" />
    </div>
  } @else {
    <lib-or-avatar [avatarUrl]="channelImage()" [initials]="channelName()" [avatarSize]="'sm'" [rightMargin]="true">
    </lib-or-avatar>
  }

  <div class="or-flex-1 or-min-w-0">
    <div class="or-head-sm or-truncate or-mb-4-px" [innerHTML]="channelName() | highlightMatch: highlightQuery()"></div>
    <div class="or-text-sm or-color-secondary-2 or-truncate">{{ lastMessage() }}</div>
  </div>

  <div class="or-d-flex or-align-items-center or-ml-8-px channel-meta">
    @if (isMuted()) {
      <or-icon name="notifications-muted" size="xxs" class="or-mr-8-px" boxed />
    }
    <div class="or-d-flex or-flex-col or-align-items-center or-justify-content-center channel-meta-right">
      <span class="or-note-sm or-color-secondary-2">{{ lastMessageTime() }}</span>
      @if (unreadCount() > 0) {
        <span class="unread-badge or-bg-main-1 or-color-white or-head-xs or-mt-4-px">
          {{ unreadCount() > 99 ? '99+' : unreadCount() }}
        </span>
      }
    </div>
  </div>
</div>
